module.exports = __webpack_public_path__ + "media/images/thumbs/atlas/afore32-72dc3e255f101cff43fe2765c07edcba.jpg";